import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Header, Button, Input } from "semantic-ui-react";
import { projectDelete } from "../../actions/projectActions";

const ProjectDeleteForm = ({ projectId, closeModal }) => {
  const dispatch = useDispatch();
  const project = useSelector((state) => state.projects.hash[projectId]);
  const [confirm, setConfirm] = useState("");
  return (
    <>
      <Header as="h3" color="red">
        You are going to remove {project.name}. Removed project CANNOT be
        restored! Are you ABSOLUTELY sure?
      </Header>
      <p>
        This action can lead to data loss. To prevent accidental actions we ask
        you to confirm your intention. Please type
        <span style={{ backgroundColor: "#fbe5e1", color: "#c0341d" }}>
          {" "}
          {project.name}{" "}
        </span>
        to proceed or close this modal to cancel.
      </p>
      <Input
        style={{ display: "block", marginBottom: "1em" }}
        onChange={(e) => setConfirm(e.target.value)}
      />
      <Button onClick={() => closeModal()} content="Cancel" />
      <Button
        color="red"
        disabled={confirm !== project.name}
        onClick={() => {
          dispatch(projectDelete(projectId));
          closeModal();
        }}
        content="Delete"
      />
    </>
  );
};

ProjectDeleteForm.propTypes = {
  projectId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ProjectDeleteForm;
